import EnquiriesTable from './enquiries/EnquiriesTable';

export default function EnquiryList() {
  return <EnquiriesTable />;
}
